import axios from 'axios'
import { baseURL } from './api'
const http = axios.create({ baseURL })
http.interceptors.request.use(config => { config.headers.authorization = `Bearer ${localStorage.accessToken || ''}`; return config })
export const adminPassportApi = {
    get: path => http.get(path).then(r => r.data),
    post: (path, body) => http.post(path, body).then(r => r.data),
    patch: (path, body) => http.patch(path, body).then(r => r.data)
}
